import React from "react";
import PropTypes from "prop-types";
import FileLoader from "../../hoc/fileLoader";
import { useDispatch, useSelector } from "react-redux";
import { getFileUpload } from "../../../store/fileUpload";
import { updateStart } from "../../../store/start";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../../i18n/LanguageContext";

function Form({
  playId,
  taskId,
  isLoading,
  videoFiles,
  handleLoadVideo,
  start,
  handleUpload,
}) {
  const files = useSelector(getFileUpload(playId, taskId));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useI18n();
  const handleCheck = () => {
    dispatch(updateStart({ ...start, check: true }));
    navigate(-1);
  };
  return (
    <FileLoader>
      <div className="mx-3">
        {files.length <= 2 && (
          <form className="flex flex-col items-center">
            <label
              htmlFor="fileUpload"
              className="pr-2 font-serif text-lg font-bold py-3"
            >
              {t("form.uploadLabel")}
            </label>

            {!isLoading && (
              <input
                id="fileUpload"
                multiple
                name="video"
                type="file"
                accept=".mkv, .mov, .mp4, .avi"
                onChange={handleLoadVideo}
              />
            )}
          </form>
        )}
        {videoFiles !== null && files.length <= 2 ? (
          <div className="flex w-full justify-center">
            <button
              onClick={handleUpload}
              className="px-5 py-2 m-5 rounded bg-green-400 mr-5 hover:bg-green-500"
              disabled={isLoading}
            >
              {t("form.upload")}
            </button>
          </div>
        ) : (
          <div className="p-5">
            {t("form.checkQuality")}
          </div>
        )}
        {isLoading && <p className="flex justify-center">{t("loader.wait")}</p>}

        {files &&
          files.map((elem, index) => (
            <p key={index} className="bg-green-200 px-2 py-1">
              {t("form.uploaded", { name: elem.filename })}
            </p>
          ))}

        <div className="flex flex-col justify-center">
          <div className="mx-3">
            {t("form.reminder")}
          </div>
          <button
            type="button"
            onClick={handleCheck}
            className="w-40 h-10 m-5 rounded bg-green-400 mr-5 hover:bg-green-500"
            disabled={files && files.length > 0 ? false : true}
          >
            {t("form.done")}
          </button>
        </div>
        <div className="text-red-500 text-sm">
          * {t("form.lowercase")}
        </div>
      </div>
    </FileLoader>
  );
}

Form.propTypes = {
  videoFiles: PropTypes.object || null,
  handleLoadVideo: PropTypes.func,
  handleUpload: PropTypes.func,
};

export default Form;
